module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-contact"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-content contact"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-4 text-center"
  }, [_vm._m(1), _vm._v(" "), _c('h2', [_vm._v("CONTACT US")]), _vm._v(" "), _c('p', [_vm._v("1-800-288-6447")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "button"
  }, [_c('router-link', {
    staticClass: "learn-more-button gray",
    attrs: {
      "to": "/open-info-request-website",
      "tag": "button"
    }
  }, [_c('span', [_vm._v("REQUEST MORE INFO")])])], 1), _vm._v(" "), _c('p', {
    staticClass: "button"
  }, [_c('router-link', {
    staticClass: "learn-more-button gray",
    attrs: {
      "to": "/open-callback-website",
      "tag": "button"
    }
  }, [_c('span', [_vm._v("REQUEST A CALLBACK")])])], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbo-wrapper contact"
  }, [_c('div', {
    staticClass: "jumbo-main"
  }, [_c('div', {
    staticClass: "jumbo-content"
  }, [_c('p', {
    staticClass: "t15"
  }, [_vm._v("CONTACT")]), _vm._v(" "), _c('h2', {
    staticClass: "t42"
  }, [_vm._v("\n                        LET US KNOW\n                        "), _c('br'), _vm._v("\n                        HOW WE CAN HELP!\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "t20"
  }, [_vm._v("Our business is your success!")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-box"
  }, [_c('div', {
    staticClass: "phone-icon"
  }, [_c('img', {
    attrs: {
      "src": "images/Contact-Page/phoneicon.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "mailto:bricks@fundraisersltd.com"
    }
  }, [_vm._v("bricks@bricksrus.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-4 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('div', {
    staticClass: "address-icon"
  }, [_c('img', {
    attrs: {
      "src": "images/Contact-Page/addressicon.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('h2', [_vm._v("MAILING ADDRESS")]), _vm._v(" "), _c('p', [_vm._v("Fund Raisers, Ltd.")]), _vm._v(" "), _c('p', [_vm._v("2700 E. Lanark St")]), _vm._v(" "), _c('p', [_vm._v("Suite 120")]), _vm._v(" "), _c('p', [_vm._v("Boise, ID 83642")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-4 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('div', {
    staticClass: "clock-icon"
  }, [_c('img', {
    attrs: {
      "src": "images/Contact-Page/hoursicon.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('h2', [_vm._v("OFFICE HOURS")]), _vm._v(" "), _c('p', [_vm._v("Monday - Friday")]), _vm._v(" "), _c('p', [_vm._v("9am - 6pm CST")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79b0a962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 6LWH
// module chunks = 1